import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import Logo from './Logo';

const Navigation = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { name: 'Features', path: '/features' },
    { name: 'Industries', path: '/industries' },
    { name: 'Results', path: '/case-studies' },
    { name: 'Pricing', path: '/pricing' },
    { name: 'Demo', path: '/demo' },
  ];

  return (
    <nav className={`fixed top-0 w-full z-50 transition-all duration-500 ${scrolled ? 'bg-brand-dark/80 backdrop-blur-xl py-4 border-b border-white/5' : 'bg-transparent py-6'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <Logo />

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-10">
            {navLinks.map((link) => (
              <Link 
                key={link.name} 
                to={link.path} 
                className={`text-[10px] font-black uppercase tracking-[0.2em] transition-colors ${location.pathname === link.path ? 'text-brand-cyan' : 'text-brand-gray hover:text-white'}`}
              >
                {link.name}
              </Link>
            ))}
            
            <Link to="/book-demo" className="relative group overflow-hidden rounded-full p-[1.5px]" >
              <span className="absolute inset-0 bg-gradient-to-r from-brand-blue to-brand-cyan animate-pulse"></span>
              <div className="relative bg-brand-dark px-8 py-2.5 rounded-full flex items-center gap-2 group-hover:bg-opacity-0 transition-all duration-300">
                <span className="text-[10px] font-black text-white uppercase tracking-[0.2em]">Book Demo</span>
              </div>
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-white focus:outline-none">
              <SafeIcon icon={mobileMenuOpen ? FiIcons.FiX : FiIcons.FiMenu} className="h-7 w-7" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav Overlay */}
      {mobileMenuOpen && (
        <motion.div 
          initial={{ opacity: 0, height: 0 }} 
          animate={{ opacity: 1, height: 'auto' }} 
          className="md:hidden bg-brand-dark border-b border-white/5 overflow-hidden"
        >
          <div className="px-4 pt-4 pb-10 space-y-4 text-center">
            {navLinks.map((link) => (
              <Link 
                key={link.name} 
                to={link.path} 
                className="block py-4 text-xs font-black text-brand-gray hover:text-white uppercase tracking-[0.3em]"
              >
                {link.name}
              </Link>
            ))}
            <Link 
              to="/book-demo" 
              className="block w-full py-5 bg-gradient-to-r from-brand-blue to-brand-cyan text-white rounded-xl font-black text-sm uppercase tracking-[0.2em]"
            >
              BOOK DEMO
            </Link>
          </div>
        </motion.div>
      )}
    </nav>
  );
};

export default Navigation;